/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：709
 */

"use strict"

var r = require(/* 19 */"../../../19")
var i = require(/* 2643 */"./2643")
var o = require(/* 798 */"./798/index")
exports.a = function (e) {
  var t = arguments.length > 1 && undefined !== arguments[1] ? arguments[1] : {}
  return i.a(e, r.a({
    defaultTheme: o.a
  }, t))
}
